export default __webpack_public_path__ + "static/media/pg-icon1.593cca9f.png";